import { render, staticRenderFns } from "./TaskStagesList.vue?vue&type=template&id=3f283a8f&scoped=true&"
import script from "./TaskStagesList.vue?vue&type=script&lang=js&"
export * from "./TaskStagesList.vue?vue&type=script&lang=js&"
import style0 from "./TaskStagesList.vue?vue&type=style&index=0&id=3f283a8f&lang=scss&scoped=true&"
import style1 from "./TaskStagesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f283a8f",
  null
  
)

export default component.exports